import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card relative z-20 border border-gray-200/50 dark:border-gray-700/50 shadow-sm overflow-visible" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row gap-4" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex w-full sm:w-auto gap-3" }

import { computed } from 'vue'
import SearchBar from '@/components/ui/SearchBar.vue'
import FilterDropdown from '@/components/ui/FilterDropdown.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TableControls',
  props: {
    search: {},
    status: {},
    placeholder: {},
    options: {},
    filterLabel: {},
    perPage: {}
  },
  emits: ["update:search", "update:status", "update:perPage"],
  setup(__props: any) {

const props = __props



const defaultOptions = [
	{ value: 'all', label: 'All Status' },
	{ value: 'active', label: 'Active' },
	{ value: 'inactive', label: 'Inactive' },
	{ value: 'pending', label: 'Pending' }
]

const computedOptions = computed(() => props.options || defaultOptions)

const displayLabel = computed(() => props.filterLabel || 'Status')

const perPageOptions = [
	{ value: '10', label: '10 per page' },
	{ value: '20', label: '20 per page' },
	{ value: '50', label: '50 per page' },
	{ value: '100', label: '100 per page' }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SearchBar, {
            modelValue: __props.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:search', $event))),
            placeholder: __props.placeholder
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(FilterDropdown, {
            modelValue: __props.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:status', $event))),
            label: displayLabel.value,
            options: computedOptions.value
          }, null, 8, ["modelValue", "label", "options"]),
          (__props.perPage !== undefined)
            ? (_openBlock(), _createBlock(FilterDropdown, {
                key: 0,
                modelValue: String(__props.perPage),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:perPage', Number($event)))),
                label: "Per Page",
                options: perPageOptions
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "action")
      ])
    ])
  ]))
}
}

})